<template>
    <v-card rounded="md" color="grey lighten-5" class="txt txt--xs">
        <div class="pa-10px pa-md-16px">
            <div class="mb-8px mb-md-12px">{{ cart.name }} <span v-if="cart.stock == 0">(품절)</span></div>
            <v-row no-gutters align="center">
                <v-col cols="auto">
                    <!-- 옵션 수량 -->
                    <div class="spinner">
                        <v-btn icon tile class="v-size--xx-small transparent" @click="decrease"><v-icon color="grey">mdi-minus</v-icon></v-btn>
                        <input v-model="cart.amount" class="spinner__num" type="number" @change="onChangeAmount" :disabled="!cart.stock" />
                        <v-btn icon tile class="v-size--xx-small transparent" @click="increase"><v-icon color="grey">mdi-plus</v-icon></v-btn>
                    </div>
                </v-col>
                <v-spacer />
                <v-col cols="auto">
                    <span class="d-flex align-center">
                        <strong class="font-size-16 font-size-lg-20">
                            <template v-if="userIsLoggedIn">
                                {{ (cart.salePrice * cart.amount).format() }}
                            </template>
                            <template v-else>
                                {{ (cart.publicPrice * cart.amount).format() }}
                            </template>
                        </strong>
                        <span class="pl-2px">원</span>
                    </span>
                </v-col>
                <v-col cols="auto" v-if="cart._option || cart._supply">
                    <v-btn small icon class="transparent mr-n4px mr-md-n10px" @click="$emit('pull')">
                        <v-icon class="font-size-inherit grey--text text--lighten-1">mdi-close</v-icon>
                    </v-btn>
                </v-col>
            </v-row>
            <!-- <div class="mt-4px mt-md-8px">
                <v-text-field v-model="cart.requestMessage" dense outlined hide-details placeholder="상품요청사항" @input="emit" />
            </div> -->
        </div>
    </v-card>
</template>

<script>
export default {
    props: {
        value: { type: Object, default: () => ({}) },
    },
    data: () => ({
        cart: {},
    }),
    computed: {
        userIsLoggedIn() {
            return !!this.$store.state?.payload?._user;
        },
        amount_min() {
            if (this.cart?.product?.amountMinConf?.enabled) return this.cart?.product?.amountMinConf?.value || 1;
            else return 1;
        },
    },
    methods: {
        sync() {
            this.cart = { ...(this.value || {}) };
        },
        emit() {
            this.$emit("input", { ...(this.cart || {}) });
        },
        decrease() {
            this.$nextTick(() => {
                if (this.cart.amount <= this.amount_min) this.cart.amount = this.amount_min;
                else this.cart.amount -= 1;
                this.emit();
            });
        },
        increase() {
            this.$nextTick(() => {
                if (this.cart.stock <= this.cart.amount) this.cart.amount = this.cart.stock;
                else this.cart.amount += 1;
                this.emit();
            });
        },
        onChangeAmount() {
            this.$nextTick(() => {
                if (this.cart.amount < this.amount_min) this.cart.amount = this.amount_min;
                if (this.cart.stock < this.cart.amount) this.cart.amount = this.cart.stock;
                this.emit();
            });
        },
    },
    watch: {
        value() {
            this.sync();
        },
    },
    mounted() {
        this.sync();
    },
};
</script>

<style></style>
